export enum FileAction {
  Preview = 'preview',
  UpdateACLToPublic = 'update-acl-to-public',
  UpdateACLToPrivate = 'update-acl-to-private',
  Compress = 'compress',
  CopyName = 'copy-name',
  CopyUrlLink = 'copy-url-link',
  Download = 'download',
  Delete = 'delete',
  Separator = 'separator',
  CreateNewFolder = 'create-new-folder',
  UploadFilesToCurrentFolder = 'upload-files-to-current-folder',
  DeleteCurrentFolder = 'delete-current-folder',
}
